
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter  } from "react-router-dom";

// core styles
import "./scss/fcsvendor.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import { Provider } from 'react-redux';
import store from "./store/index";
ReactDOM.render(
  <BrowserRouter >
   <Provider store={store}>
    <ScrollToTop />
    <HomePage /></Provider>
  </BrowserRouter >,
  document.getElementById("root")
);
